export function isGatewayCorrelatedResponse(message) {
    return !!message.correlationId;
}
//# sourceMappingURL=channel.models.js.map